import { errorMessage } from "@components/forms/error";
import { digitsAndWords } from "@components/forms/regexp";
import * as yup from "yup";

export const loginSchema = yup.object().shape({
  email: yup
    .string()
    .email(errorMessage.email)
    .required(errorMessage.required)
    .trim(),
  password: yup.string().required(errorMessage.required).trim(),
  code: yup.string().trim(),
});

export const enrollmentOtpschema = yup.object().shape({
  code: yup.string().required(errorMessage.required).trim(),
});

export const registerSchema = yup.object().shape({
  email: yup
    .string()
    .email(errorMessage.email)
    .required(errorMessage.required)
    .trim(),
  password: yup
    .string()
    .min(8, (params) => errorMessage.min(params.min))
    .matches(digitsAndWords, errorMessage.digitsAndWords)
    .required(() => errorMessage.required)
    .trim(),
  password_confirmation: yup
    .string()
    .required(() => errorMessage.required)
    .oneOf([yup.ref("password")], errorMessage.confirmPassword)
    .trim(),
});
